// A recursive function to merge two objects with the same structure
// Copied from web.

const isObject = (item) => {
  return item !== null && typeof item === 'object' && !Array.isArray(item)
}

export const deepMerge = (target, ...sources) => {
  if (!sources.length) return target
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        const sourceValue = source[key]
        if (isObject(sourceValue) && isObject(target[key])) {
          target[key] = deepMerge(target[key], sourceValue)
        } else {
          target[key] = sourceValue
        }
      }
    }
  }

  return deepMerge(target, ...sources)
}